<template>
  <v-container
    fluid
    class="fill-height mobile-blocker-container flex justify-center items-center pa-6"
  >
    <v-card
      class="mx-auto rounded-xl shadow-2xl glass-card text-center pa-8 border-t border-white-10"
      max-width="400"
    >
      <div class="icon-wrapper mb-6 mx-auto flex items-center justify-center">
        <v-icon size="64" color="#21427d">{{ config.icon || 'mdi-monitor' }}</v-icon>
      </div>

      <h2 class="text-h5 font-bold text-slate-800 mb-3 tracking-tight">
        {{ config.title || 'Desktop Optimized' }}
      </h2>

      <p class="text-body-2 text-slate-600 mb-8 leading-relaxed">
        {{ message || config.message }}
      </p>

      <v-btn
        color="#21427d"
        class="white--text font-bold px-6 py-3 rounded-lg shadow-md hover-scale"
        depressed
        @click="goBack"
      >
        <v-icon left size="18">mdi-arrow-left</v-icon>
        {{ config.buttonText || 'Back to Dashboard' }}
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { mobileRoutesConfig } from '@/utils/workforce/mobileRoutesConfig'

export default {
  name: 'MobileBlocker',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    config() {
      return mobileRoutesConfig.blockerConfig || {}
    }
  },
  methods: {
    goBack() {
      if (this.$route.path !== '/workforce/dashboard') {
        this.$router.push('/workforce/dashboard').catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.mobile-blocker-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.icon-wrapper {
  width: 100px;
  height: 100px;
  background: rgba(33, 66, 125, 0.1);
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.icon-wrapper:hover {
  transform: rotate(-10deg) scale(1.05);
}

.hover-scale {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hover-scale:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 66, 125, 0.3);
}
</style>
